import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2a70b67e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "@/style/form.styl?vue&type=style&index=0&id=2a70b67e&lang=stylus&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=2a70b67e&lang=stylus&scoped=true&"
import style2 from "./Index.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70b67e",
  null
  
)

export default component.exports